import { Routes } from '@angular/router';
import { StepIds } from '..//models/property-step/property-step-model';
import { ResidentialForSalePropertyDescriptionComponent } from '../pages/category-page-overrides/residential-for-sale/property-description-page.component';
import { ResidentialForSalePropertyInformationComponent } from '../pages/category-page-overrides/residential-for-sale/property-information-page.component';
import { PropertyPhotosPageComponent } from '../pages/property-default-pages/property-photos-page/property-photos-page.component';
import { PropertyPromotePageComponent } from '../pages/property-default-pages/property-promote-page/property-promote-page.component';
import { ResidentialForSalePropertySummaryPageComponent } from '../pages/category-page-overrides/residential-for-sale/property-summary-page.component';

export const residentialForSaleRoutes: Routes = [
    {
        path: '',
        redirectTo: StepIds.propertyInformation,
        pathMatch: 'full'
    },
    {
        path: StepIds.propertyInformation,
        component: ResidentialForSalePropertyInformationComponent,
        data: {
            stepInfo: {
                stepId: StepIds.propertyInformation
            }
        },
        loadChildren: () =>
            import(
                '../pages/category-page-overrides/residential-for-sale/property-information-page.module'
            ).then((mod) => mod.ResidentialForSalePropertyInformationPageModule)
    },
    {
        path: StepIds.propertyDescription,
        component: ResidentialForSalePropertyDescriptionComponent,
        data: {
            stepInfo: {
                stepId: StepIds.propertyDescription
            }
        },
        loadChildren: () =>
            import(
                '../pages/category-page-overrides/residential-for-sale/property-description-page.module'
            ).then((mod) => mod.ResidentialForSalePropertyDescriptionPageModule)
    },
    {
        path: StepIds.propertyPhotos,
        component: PropertyPhotosPageComponent,
        data: {
            stepInfo: {
                stepId: StepIds.propertyPhotos
            }
        }
    },
    {
        path: StepIds.propertyPromote,
        component: PropertyPromotePageComponent,
        data: {
            stepInfo: {
                stepId: StepIds.propertyPromote
            }
        }
    },
    {
        path: StepIds.propertySummary,
        component: ResidentialForSalePropertySummaryPageComponent,
        data: {
            stepInfo: {
                stepId: StepIds.propertySummary
            }
        },
        loadChildren: () =>
            import(
                '../pages/category-page-overrides/residential-for-sale/property-summary-page.module'
            ).then((mod) => mod.ResidentialForSalePropertySummaryPageModule)
    }
];
